export default __webpack_public_path__ + "static/media/user.8d71892c.png";